import { z } from "zod";

export const SimpleVaultCredentialKindSchema = z.enum(["api-key", "bearer-token", "basic-auth"]);
export type SimpleVaultCredentialKind = z.infer<typeof SimpleVaultCredentialKindSchema>;

export const VAULT_CREDENTIAL_FIELDS: Record<
  SimpleVaultCredentialKind,
  readonly { name: string; label: string }[]
> = {
  "api-key": [{ name: "apiKey", label: "API key" }],
  "bearer-token": [{ name: "token", label: "Bearer token" }],
  "basic-auth": [
    { name: "username", label: "Username" },
    { name: "password", label: "Password" },
  ],
};

export const VaultCredentialValueSchemas = {
  "api-key": z.object({
    apiKey: z.string().trim().min(1, "API key is missing. Enter an API key."),
  }),
  "bearer-token": z.object({
    token: z.string().trim().min(1, "Bearer token is missing. Enter a token."),
  }),
  "basic-auth": z.object({
    username: z.string().trim().min(1, "Username is missing. Enter a username."),
    password: z.string().min(1, "Password is missing. Enter a password."),
  }),
};
